import { QRCODE_DYNAMIC_MICROSITE_TYPE } from '~/constants/qr-code';

export const ANONYMOUS_QR_TEMPLATES_LIST = [
  {
    title: 'labels:website',
    description: 'landing:anonymQr.website.title',
    type: QRCODE_DYNAMIC_MICROSITE_TYPE.WEBSITE,
    icon: 'World',
    id: 0,
  },
  {
    title: 'landing:footer.pdf',
    description: 'landing:anonymQr.pdf.title',
    type: QRCODE_DYNAMIC_MICROSITE_TYPE.PDF,
    icon: 'Pdf',
    id: 1,
  },
  {
    title: 'common:listOfLinks',
    description: 'landing:anonymQr.listOfLinks.title',
    type: QRCODE_DYNAMIC_MICROSITE_TYPE.LINKS,
    icon: 'Link',
    id: 2,
  },
  {
    title: 'landing:footer.vcard',
    description: 'landing:anonymQr.vCard.title',
    type: QRCODE_DYNAMIC_MICROSITE_TYPE.VCARD_PLUS,
    icon: 'UserId',
    id: 5,
  },
  {
    title: 'landing:footer.images',
    description: 'landing:anonymQr.images.title',
    type: QRCODE_DYNAMIC_MICROSITE_TYPE.IMAGES,
    icon: 'Photo',
    id: 4,
  },
  {
    title: 'landing:footer.social',
    description: 'landing:anonymQr.social.title',
    type: QRCODE_DYNAMIC_MICROSITE_TYPE.SOCIAL_MEDIA,
    icon: 'SocialMedia',
    id: 6,
  },
  {
    title: 'landing:footer.apps',
    description: 'landing:anonymQr.apps.title',
    type: QRCODE_DYNAMIC_MICROSITE_TYPE.APP,
    icon: 'DeviceMobile',
    id: 3,
  },
  {
    title: 'createQrStep1:items.b8.name',
    description: 'createQrStep1:items.b8.subName',
    type: QRCODE_DYNAMIC_MICROSITE_TYPE.COUPON,
    icon: 'Coupon',
    id: 7,
  },
  {
    title: 'createQrStep1:items.b9.name',
    description: 'createQrStep1:items.b9.subName',
    type: QRCODE_DYNAMIC_MICROSITE_TYPE.VIDEO,
    icon: 'Video',
    id: 8,
  },
  {
    title: 'landing:anonymQr.more.title',
    description: '',
    type: 'more',
    icon: 'Design',
    disabled: true,
  },
];

export const TEMPLATE_SEARCH_PARAM = 'type';
